var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "stars" },
    [
      _vm.value > 0
        ? [
            _vm.short
              ? [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("span", {
                      staticClass: "mr-2",
                      class: _vm.activeClasses,
                    }),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.value + " / " + _vm.limit),
                      },
                    }),
                  ]),
                ]
              : [
                  _vm._l(_vm.activeStars, function (_) {
                    return _c("span", { class: _vm.activeClasses })
                  }),
                  _vm._l(_vm.inactiveStars, function (_) {
                    return _c("span", { class: _vm.inactiveClasses })
                  }),
                ],
          ]
        : [_c("span", [_vm._v("-")])],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }